import { storage } from './storage.js';
import { admin } from './admin.js';

export const app = {
  activeSection: 'books',
  activeFilter: 'all',
  searchQuery: '',

  init() {
    this.bindEvents();
    this.render();
    this.updateStats();

    // Listen to storage events from admin or import
    window.addEventListener('storage-updated', () => {
      this.render();
      this.updateStats();
    });
  },

  bindEvents() {
    // Top Navigation Section Links
    const navLinks = document.querySelectorAll('.nav-link');
    navLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetSection = e.currentTarget.dataset.section;
        this.switchSection(targetSection);
        
        // Close mobile menu if open
        const navMenu = document.querySelector('.nav-menu');
        if (navMenu) navMenu.classList.remove('mobile-open');
      });
    });

    // Mobile Menu Toggle
    const mobileMenuBtn = document.getElementById('mobile-menu-toggle');
    if (mobileMenuBtn) {
      mobileMenuBtn.addEventListener('click', () => {
        const navMenu = document.querySelector('.nav-menu');
        if (navMenu) navMenu.classList.toggle('mobile-open');
      });
    }

    // Logo Click -> Go to books (Home)
    const brandLogo = document.querySelector('.brand-logo');
    if (brandLogo) {
      brandLogo.addEventListener('click', (e) => {
        e.preventDefault();
        this.switchSection('books');
      });
    }

    // Search Input
    const searchInput = document.getElementById('global-search-input');
    const searchClear = document.getElementById('search-clear');
    if (searchInput) {
      searchInput.addEventListener('input', (e) => {
        this.searchQuery = e.target.value.toLowerCase().trim();
        if (searchClear) {
          searchClear.style.display = this.searchQuery ? 'block' : 'none';
        }
        this.renderCurrentSection();
      });
    }

    if (searchClear) {
      searchClear.addEventListener('click', () => {
        if (searchInput) searchInput.value = '';
        this.searchQuery = '';
        searchClear.style.display = 'none';
        this.renderCurrentSection();
      });
    }

    // Detail Modal Close
    const detailClose = document.getElementById('detail-modal-close');
    const detailOverlay = document.getElementById('detail-modal');
    if (detailClose) {
      detailClose.addEventListener('click', () => this.closeDetailModal());
    }
    if (detailOverlay) {
      detailOverlay.addEventListener('click', (e) => {
        if (e.target === detailOverlay) this.closeDetailModal();
      });
    }

    // ESC key closes modals
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeDetailModal();
        admin.closePinModal();
        admin.closeAdminModal();
        admin.closeFormModal();
      }
    });
  },

  switchSection(sectionName) {
    this.activeSection = sectionName;
    this.activeFilter = 'all'; // Reset filter when switching section

    // Update nav links
    document.querySelectorAll('.nav-link').forEach(link => {
      link.classList.toggle('active', link.dataset.section === sectionName);
    });

    // Update Hero Title & Description based on section
    this.updateHero();

    // Render section content
    this.render();

    // Scroll smoothly to section
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },

  updateHero() {
    const titles = {
      books: {
        title: `کتێبخانەی <span class="highlight">دیجیتاڵی و سەردەمی</span>`,
        desc: `دەستگەیشتن بە سەدان کتێبی هەڵبژێردراوی کوردی و جیهانی لە بوارە جیاوازەکانی زانست، ڕۆمان، تەکنەلۆژیا و گەشەپێدان.`
      },
      films: {
        title: `جیهانی <span class="highlight">فیلم، ئەنیمێ و کارتۆن</span>`,
        desc: `سەیری نوێترین و بەناوبانگترین فیلمە جیهانییەکان، زنجیرە ئەنیمێیە ژاپۆنییەکان و کارتۆنە یادگارییەکان بکە بە کوالێتی بەرز.`
      },
      games: {
        title: `باشترین و نوێترین <span class="highlight">یارییە ڤیدیۆییەکان</span>`,
        desc: `کۆکراوەی بەهێزترین یارییەکانی کۆمپیوتەر، پلەیستەیشن، ئێکس بۆکس و مۆبایل لەگەڵ زانیاری و لینکی فەرمی داگرتن.`
      },
      apps: {
        title: `نەرمەکاڵا و <span class="highlight">ئەپڵیکەیشنە پێویستەکان</span>`,
        desc: `باشترین بەرنامەکانی دیزاین، بەرنامەسازی، مۆنتاژ و ئامرازە بەسوودەکان بۆ کۆمپیوتەر و مۆبایلەکەت بدۆزەرەوە.`
      },
      about: {
        title: `دەربارەی <span class="highlight">دامەزرێنەران و بەڕێوەبەران</span>`,
        desc: `ئێمە دوو گەنجی خولیای تەکنەلۆژیا و میدیاین، کار دەکەین بۆ پێشکەشکردنی باشترین ئەزموونی دیجیتاڵی بۆ ئێوە.`
      }
    };

    const heroTitleEl = document.getElementById('hero-title');
    const heroDescEl = document.getElementById('hero-desc');
    if (heroTitleEl && titles[this.activeSection]) {
      heroTitleEl.innerHTML = titles[this.activeSection].title;
    }
    if (heroDescEl && titles[this.activeSection]) {
      heroDescEl.textContent = titles[this.activeSection].desc;
    }
  },

  updateStats() {
    const stats = storage.getStats();
    const statBooks = document.getElementById('stat-books-count');
    const statFilms = document.getElementById('stat-films-count');
    const statGames = document.getElementById('stat-games-count');
    const statApps = document.getElementById('stat-apps-count');

    if (statBooks) statBooks.textContent = stats.books;
    if (statFilms) statFilms.textContent = stats.films;
    if (statGames) statGames.textContent = stats.games;
    if (statApps) statApps.textContent = stats.apps;
  },

  render() {
    // Show/hide sections
    const standardSection = document.getElementById('standard-content-section');
    const aboutSection = document.getElementById('about-content-section');

    if (this.activeSection === 'about') {
      if (standardSection) standardSection.style.display = 'none';
      if (aboutSection) aboutSection.style.display = 'block';
      this.renderAboutSection();
    } else {
      if (aboutSection) aboutSection.style.display = 'none';
      if (standardSection) standardSection.style.display = 'block';
      this.renderSubFilters();
      this.renderCurrentSection();
    }
  },

  renderSubFilters() {
    const filterContainer = document.getElementById('section-filters-bar');
    if (!filterContainer) return;

    let filters = [];

    if (this.activeSection === 'films') {
      filters = [
        { id: 'all', label: 'هەموو پۆلەکان', icon: 'fa-layer-group' },
        { id: 'movie', label: 'فیلم (Movies)', icon: 'fa-film' },
        { id: 'anime', label: 'ئەنیمێ (Anime)', icon: 'fa-wand-magic-sparkles' },
        { id: 'cartoon', label: 'کارتۆن (Cartoons)', icon: 'fa-child-reaching' },
        { id: 'series', label: 'زنجیرە (Series)', icon: 'fa-tv' }
      ];
    } else if (this.activeSection === 'books') {
      filters = [
        { id: 'all', label: 'هەموو کتێبەکان', icon: 'fa-book-open' },
        { id: 'ڕۆمان', label: 'ڕۆمان و چیرۆک', icon: 'fa-feather' },
        { id: 'مرۆیی', label: 'گەشەپێدانی مرۆیی', icon: 'fa-brain' },
        { id: 'تەکنەلۆژیا', label: 'تەکنەلۆژیا', icon: 'fa-laptop-code' },
        { id: 'مێژوو', label: 'مێژوو و زانست', icon: 'fa-landmark' }
      ];
    } else if (this.activeSection === 'games') {
      filters = [
        { id: 'all', label: 'هەموو یارییەکان', icon: 'fa-gamepad' },
        { id: 'PC', label: 'کۆمپیوتەر (PC)', icon: 'fa-desktop' },
        { id: 'PS', label: 'پلەیستەیشن (PlayStation)', icon: 'fa-playstation' },
        { id: 'Xbox', label: 'ئێکس بۆکس (Xbox)', icon: 'fa-xbox' },
        { id: 'Mobile', label: 'مۆبایل (Mobile)', icon: 'fa-mobile-screen-button' }
      ];
    } else if (this.activeSection === 'apps') {
      filters = [
        { id: 'all', label: 'هەموو بەرنامەکان', icon: 'fa-cubes' },
        { id: 'Windows', label: 'Windows', icon: 'fa-windows' },
        { id: 'macOS', label: 'macOS / Apple', icon: 'fa-apple' },
        { id: 'Linux', label: 'Linux', icon: 'fa-linux' },
        { id: 'Mobile', label: 'مۆبایل', icon: 'fa-mobile-screen' }
      ];
    }

    let html = '';
    filters.forEach(f => {
      const activeClass = this.activeFilter === f.id ? 'active' : '';
      html += `
        <button class="filter-pill ${activeClass}" data-filter="${f.id}">
          <i class="fa-solid ${f.icon}"></i>
          <span>${f.label}</span>
        </button>
      `;
    });

    filterContainer.innerHTML = html;

    // Bind click events on filter pills
    filterContainer.querySelectorAll('.filter-pill').forEach(btn => {
      btn.addEventListener('click', (e) => {
        this.activeFilter = e.currentTarget.dataset.filter;
        filterContainer.querySelectorAll('.filter-pill').forEach(b => b.classList.remove('active'));
        e.currentTarget.classList.add('active');
        this.renderCurrentSection();
      });
    });
  },

  renderCurrentSection() {
    const gridContainer = document.getElementById('content-items-grid');
    const countBadge = document.getElementById('section-items-count');
    const sectionTitle = document.getElementById('section-main-title');
    if (!gridContainer) return;

    let items = storage.getSectionItems(this.activeSection);

    // Apply Filter Tab
    if (this.activeFilter !== 'all') {
      if (this.activeSection === 'films') {
        items = items.filter(i => i.type === this.activeFilter);
      } else if (this.activeSection === 'books') {
        items = items.filter(i => (i.category || '').toLowerCase().includes(this.activeFilter.toLowerCase()));
      } else if (this.activeSection === 'games') {
        items = items.filter(i => (i.platform || '').toLowerCase().includes(this.activeFilter.toLowerCase()));
      } else if (this.activeSection === 'apps') {
        items = items.filter(i => (i.os || '').toLowerCase().includes(this.activeFilter.toLowerCase()));
      }
    }

    // Apply Universal Search Query
    if (this.searchQuery) {
      items = items.filter(item => {
        const text = [
          item.title,
          item.titleKurdish,
          item.author,
          item.category,
          item.genre,
          item.description,
          item.developer,
          item.platform,
          item.os
        ].filter(Boolean).join(' ').toLowerCase();

        return text.includes(this.searchQuery);
      });
    }

    // Update section info badge
    if (countBadge) countBadge.textContent = `${items.length} بەردەستە`;

    const sectionTitles = {
      books: '<i class="fa-solid fa-book-open"></i> بەشی کتێبەکان (Books)',
      films: '<i class="fa-solid fa-film"></i> بەشی فیلم، ئەنیمێ و کارتۆن (Cinema & Anime)',
      games: '<i class="fa-solid fa-gamepad"></i> بەشی یارییەکان (Games)',
      apps: '<i class="fa-solid fa-shapes"></i> بەشی ئەپڵیکەیشنەکان (Applications)'
    };
    if (sectionTitle) sectionTitle.innerHTML = sectionTitles[this.activeSection] || 'ناوەڕۆک';

    // Set class on grid container
    gridContainer.className = `items-grid ${this.activeSection}-grid`;

    if (items.length === 0) {
      gridContainer.innerHTML = `
        <div class="empty-state" style="grid-column: 1 / -1;">
          <i class="fa-solid fa-magnifying-glass"></i>
          <h3>هیچ ئەنجامێک نەدۆزرایەوە</h3>
          <p>تکایە فلتەرەکە بگۆڕە یان وشەیەکی تر لە سێرچدا تاقی بکەرەوە.</p>
        </div>
      `;
      return;
    }

    // Render items based on section
    if (this.activeSection === 'books') {
      gridContainer.innerHTML = items.map(book => this.createBookCard(book)).join('');
    } else if (this.activeSection === 'films') {
      gridContainer.innerHTML = items.map(film => this.createFilmCard(film)).join('');
    } else if (this.activeSection === 'games') {
      gridContainer.innerHTML = items.map(game => this.createGameCard(game)).join('');
    } else if (this.activeSection === 'apps') {
      gridContainer.innerHTML = items.map(app => this.createAppCard(app)).join('');
    }

    // Bind Card Click for Detail Modal
    gridContainer.querySelectorAll('[data-item-id]').forEach(card => {
      card.addEventListener('click', (e) => {
        // Prevent opening if clicked on direct link button
        if (e.target.closest('a') && e.target.closest('a').getAttribute('href')) return;
        const itemId = card.dataset.itemId;
        this.openDetailModal(this.activeSection, itemId);
      });
    });
  },

  createBookCard(book) {
    const title = book.titleKurdish ? `${book.titleKurdish}` : book.title;
    const subTitle = book.titleKurdish ? book.title : (book.author || '');
    return `
      <div class="book-card" data-item-id="${book.id}">
        <div class="book-cover-wrap">
          <img class="book-cover" src="${book.cover}" alt="${book.title}" loading="lazy" onerror="this.src='https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=600'"/>
          <span class="book-category-tag">${book.category || 'کتێب'}</span>
          <span class="book-rating"><i class="fa-solid fa-star"></i> ${book.rating || '4.8'}</span>
        </div>
        <div class="book-info">
          <h3 class="book-title" title="${title}">${title}</h3>
          <p class="book-author">${subTitle}</p>
          <div class="book-footer">
            <span><i class="fa-regular fa-file-lines"></i> ${book.pages ? book.pages + ' ل.' : 'PDF'}</span>
            <span><i class="fa-regular fa-calendar"></i> ${book.year || '2023'}</span>
          </div>
        </div>
      </div>
    `;
  },

  createFilmCard(film) {
    const title = film.titleKurdish || film.title;
    const typeNames = {
      movie: 'فیلم',
      anime: 'ئەنیمێ',
      cartoon: 'کارتۆن',
      series: 'زنجیرە'
    };
    const typeLabel = typeNames[film.type] || 'فیلم';
    return `
      <div class="film-card" data-item-id="${film.id}">
        <div class="film-poster-wrap">
          <img class="film-poster" src="${film.poster}" alt="${film.title}" loading="lazy" onerror="this.src='https://images.unsplash.com/photo-1534447677768-be436bb09401?w=600'"/>
          <div class="film-play-overlay">
            <div class="play-circle"><i class="fa-solid fa-play"></i></div>
          </div>
          <span class="film-type-badge type-${film.type || 'movie'}">${typeLabel}</span>
          ${film.quality ? `<span class="film-quality-badge">${film.quality}</span>` : ''}
          <span class="film-rating-badge"><i class="fa-solid fa-star"></i> ${film.rating || '8.5'}</span>
        </div>
        <div class="film-info">
          <h3 class="film-title" title="${title}">${title}</h3>
          <p class="film-genre">${film.genre || film.title}</p>
          <div class="film-meta">
            <span><i class="fa-regular fa-clock"></i> ${film.duration || '2h'}</span>
            <span><i class="fa-regular fa-calendar"></i> ${film.year || '2023'}</span>
          </div>
        </div>
      </div>
    `;
  },

  createGameCard(game) {
    const title = game.titleKurdish || game.title;
    return `
      <div class="game-card" data-item-id="${game.id}">
        <div class="game-banner-wrap">
          <img class="game-banner" src="${game.banner}" alt="${game.title}" loading="lazy" onerror="this.src='https://images.unsplash.com/photo-1542751371-adc38448a05e?w=800'"/>
          <span class="game-platform-tag"><i class="fa-solid fa-gamepad"></i> ${game.platform || 'PC / Console'}</span>
          ${game.fileSize ? `<span class="game-size-tag"><i class="fa-solid fa-hard-drive"></i> ${game.fileSize}</span>` : ''}
        </div>
        <div class="game-info">
          <div class="game-header">
            <h3 class="game-title">${title}</h3>
            <span class="game-rating"><i class="fa-solid fa-star"></i> ${game.rating || '4.9'}</span>
          </div>
          <p class="game-desc">${game.description || game.genre || ''}</p>
          <div class="game-footer">
            <span class="game-dev"><i class="fa-regular fa-building"></i> ${game.developer || game.releaseYear || ''}</span>
            <span class="btn-game-dl"><i class="fa-solid fa-arrow-down"></i> داگرتن</span>
          </div>
        </div>
      </div>
    `;
  },

  createAppCard(app) {
    const title = app.titleKurdish || app.title;
    const osList = (app.os || 'Windows').split(',').map(s => s.trim());
    return `
      <div class="app-card" data-item-id="${app.id}">
        <div class="app-top">
          <img class="app-icon" src="${app.icon}" alt="${app.title}" loading="lazy" onerror="this.src='https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=200'"/>
          <div class="app-main-meta">
            <h3 class="app-title">${title}</h3>
            <span class="app-category">${app.category || 'نەرمەکاڵا'}</span>
            <div class="app-os-pills">
              ${osList.map(os => `<span class="os-pill">${os}</span>`).join('')}
            </div>
          </div>
        </div>
        <p class="app-desc">${app.description || ''}</p>
        <div class="app-footer">
          <div class="app-version-size">
            <span><strong>${app.version || 'v1.0'}</strong> • ${app.size || '30MB'}</span>
            <span>${app.developer || 'Official'}</span>
          </div>
          <span class="btn-app-dl"><i class="fa-solid fa-download"></i> داگرتن</span>
        </div>
      </div>
    `;
  },

  renderAboutSection() {
    const aboutData = storage.getAbout();
    const bannerTitle = document.getElementById('about-banner-title');
    const bannerSubtitle = document.getElementById('about-banner-subtitle');
    const personsGrid = document.getElementById('persons-grid');

    if (bannerTitle) bannerTitle.textContent = aboutData.title || 'دەربارەی بەڕێوەبەران و خاوەنانی پڕۆژە';
    if (bannerSubtitle) bannerSubtitle.textContent = aboutData.subtitle || 'پلاتفۆرمی هاوبەشی ئێمە بۆ پێشکەشکردنی باشترین خزمەتگوزاری دیجیتاڵی';

    if (!personsGrid) return;

    const persons = aboutData.persons || [];
    personsGrid.innerHTML = persons.map((person, index) => `
      <div class="person-card">
        <div class="person-banner-wrap">
          <img class="person-banner" src="${person.banner || 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=800'}" alt="${person.name} Banner" onerror="this.src='https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=800'"/>
          <div class="person-banner-overlay"></div>
        </div>
        <div class="person-card-body">
          <div class="person-avatar-wrap">
            <img class="person-avatar" src="${person.avatar}" alt="${person.name}" onerror="this.src='https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=600'"/>
            <span class="person-badge-num">${index + 1}</span>
          </div>
          <h3 class="person-name">${person.name}</h3>
          <span class="person-role">${person.role}</span>
          <p class="person-bio">${person.bio}</p>
          <div class="person-skills">
            ${(person.skills || []).map(skill => `<span class="skill-tag">${skill}</span>`).join('')}
          </div>
          <div class="person-socials">
            ${person.social?.discord ? `
              <a class="social-link discord-link-btn" href="${person.social.discord}" target="_blank" rel="noopener" title="پەیوەندیکردن لە دیسکۆرد">
                <i class="fa-brands fa-discord"></i>
                <span>پەیوەندی لە دیسکۆرد (Discord)</span>
              </a>
            ` : ''}
          </div>
        </div>
      </div>
    `).join('');
  },

  openDetailModal(section, id) {
    const items = storage.getSectionItems(section);
    const item = items.find(i => i.id === id);
    if (!item) return;

    const modal = document.getElementById('detail-modal');
    const modalBody = document.getElementById('detail-modal-body');
    if (!modal || !modalBody) return;

    const imageSrc = item.cover || item.poster || item.banner || item.icon;
    const titleKurdish = item.titleKurdish || '';
    const mainTitle = item.title;

    let metaTags = [];
    if (item.category) metaTags.push(`<span class="detail-tag"><i class="fa-solid fa-tag"></i> ${item.category}</span>`);
    if (item.genre) metaTags.push(`<span class="detail-tag"><i class="fa-solid fa-clapperboard"></i> ${item.genre}</span>`);
    if (item.year || item.releaseYear) metaTags.push(`<span class="detail-tag"><i class="fa-regular fa-calendar"></i> ${item.year || item.releaseYear}</span>`);
    if (item.rating) metaTags.push(`<span class="detail-tag" style="color: #fbbf24;"><i class="fa-solid fa-star"></i> ${item.rating}</span>`);
    if (item.platform) metaTags.push(`<span class="detail-tag"><i class="fa-solid fa-gamepad"></i> ${item.platform}</span>`);
    if (item.os) metaTags.push(`<span class="detail-tag"><i class="fa-solid fa-laptop"></i> ${item.os}</span>`);
    if (item.pages) metaTags.push(`<span class="detail-tag"><i class="fa-regular fa-file-lines"></i> ${item.pages} لاپەڕە</span>`);
    if (item.duration) metaTags.push(`<span class="detail-tag"><i class="fa-regular fa-clock"></i> ${item.duration}</span>`);
    if (item.fileSize || item.size) metaTags.push(`<span class="detail-tag"><i class="fa-solid fa-hard-drive"></i> ${item.fileSize || item.size}</span>`);

    let actionButtons = '';
    const dlLink = item.downloadUrl || item.watchUrl || '#';
    const hasDl = dlLink !== '#';

    if (section === 'films' && item.watchUrl) {
      actionButtons += `
        <a href="${item.watchUrl}" target="_blank" rel="noopener" class="btn-primary-action">
          <i class="fa-solid fa-play"></i> بینینی ترەیلەر یان فیلم
        </a>
      `;
    } else if (hasDl) {
      actionButtons += `
        <a href="${dlLink}" target="_blank" rel="noopener" class="btn-primary-action">
          <i class="fa-solid fa-download"></i> داگرتن / سەردانیکردنی لینک
        </a>
      `;
    }

    actionButtons += `
      <button class="btn-secondary-action" onclick="app.closeDetailModal()">
        <i class="fa-solid fa-xmark"></i> داخستن
      </button>
    `;

    modalBody.innerHTML = `
      <div class="detail-header">
        <img class="detail-poster" src="${imageSrc}" alt="${mainTitle}" onerror="this.src='https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=600'"/>
        <div class="detail-info">
          ${titleKurdish ? `<div class="detail-kurdish-title">${titleKurdish}</div>` : ''}
          <h2 class="detail-title">${mainTitle}</h2>
          ${item.author ? `<p style="color: #94a3b8; margin-bottom: 0.8rem;"><i class="fa-solid fa-pen-nib"></i> نوسەر: <strong>${item.author}</strong></p>` : ''}
          ${item.developer ? `<p style="color: #94a3b8; margin-bottom: 0.8rem;"><i class="fa-solid fa-building"></i> گەشەپێدەر: <strong>${item.developer}</strong></p>` : ''}
          <div class="detail-meta-tags">
            ${metaTags.join('')}
          </div>
        </div>
      </div>
      <div class="detail-desc-title">دەربارە و کورتەی ناوەڕۆک:</div>
      <div class="detail-description">${item.description || 'هیچ ڕوونکردنەوەیەک دانەنراوە.'}</div>
      <div class="detail-actions">
        ${actionButtons}
      </div>
    `;

    modal.classList.add('active');
  },

  closeDetailModal() {
    const modal = document.getElementById('detail-modal');
    if (modal) modal.classList.remove('active');
  }
};

window.app = app;

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  app.init();
  admin.init();
});
